module.exports = __webpack_public_path__ + "static/media/login-back.a6a3191c.png";